import { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async () => {
    try {
      const response = await axios.post('https://whats-app.360websitedemo.com/api/forgot-password', {
        email,
      });
      setMessage(response.data.message);
      setEmail('');
      setError('');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send reset link');
      setMessage('');
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="w-full max-w-4xl flex bg-white shadow-lg rounded-lg overflow-hidden">
        <div className="w-1/2 bg-green-700 text-white p-8">
          <h1 className="text-2xl font-bold mb-4">WhatsApp Sender</h1>
          <p className="mb-6">Reset your password to continue messaging</p>
          <div className="space-y-4">
            <p className="text-green-100">Secure account recovery</p>
            <p className="text-green-100">Quick and easy process</p>
          </div>
        </div>
        <div className="w-1/2 p-8">
          <h2 className="text-xl font-semibold mb-6">Forgot Password</h2>
          <p className="text-gray-600 mb-6">Enter your email to receive a password reset link</p>
          {error && <p className="text-red-500 mb-4">{error}</p>}
          {message && <p className="text-green-600 mb-4">{message}</p>}
          <div className="space-y-4">
            <div>
              <label className="block text-gray-700 text-sm font-medium mb-1">Email address</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded"
                placeholder="you@example.com"
                required
              />
            </div>
            <button
              type="button"
              onClick={handleSubmit}
              className="w-full bg-blue-600 text-white p-2 rounded hover:bg-blue-700"
            >
              Send Reset Link
            </button>
          </div>
          <p className="mt-4 text-center text-gray-600 text-sm">
            <Link to="/" className="text-blue-600 hover:underline">Back to Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;